import React, { useState , useRef, useEffect} from 'react';
import styles from './needleOverlayBox.module.css';
import { useGlobalState } from '../../../global_state_components/GlobalStateProvider';
import Needle from '../Needle/Needle';

//You need not wrap this with a memo I guess as this does not have any props.
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!But you can optimise this more I guess.
const NeedleOverlayBox = () => {
  const {heightOfCalendarGrid} = useGlobalState();

  //---------------Setting current time in seconds------------------
  const [currentTimeInSeconds, setCurrentTimeInSeconds] = useState();    //Out of 86,400 seconds in a day.

  useEffect(() => {
    const getSecondsForDay = () => {
      const now = new Date();
      const seconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

      return seconds;
    };

    // Update the time every second
    const intervalId = setInterval(() => {
      const currentSecond = getSecondsForDay();
      setCurrentTimeInSeconds(currentSecond);
    }, 1000);   //Maybe we can give this as 2,000 i.e 2 seconds.

    // Cleanup interval when component unmounts
    return () => clearInterval(intervalId);
  }, []);     // [numberOfTimesCalendarArrowClicked, datesWithDayMonthYear]     //Actually I think these dependencies are not needed. As the time is updated every second.
  //----------------------------------------------------------------------



  //----------------------setTimeNeedlePosition state for the time needle.---------------------
  const [timeNeedlePosition, setTimeNeedlePosition] =  useState();
  useEffect(()=>{
    if(heightOfCalendarGrid!==undefined){
      //setTimeNeedlePosition(Math.floor((currentTimeInSeconds*(97*heightOfCalendarGrid+23))/86400));
      //setTimeNeedlePosition(Math.floor((currentTimeInSeconds*(101*heightOfCalendarGrid))/90900));
      setTimeNeedlePosition(Math.floor(((currentTimeInSeconds/90900)*(101*heightOfCalendarGrid+59))));
    }
  },[currentTimeInSeconds]);
  //-------------------------------------------------------------------------------------------



  return (
    <div className={styles.time_needle_box_overlay} style={{height : `${101*heightOfCalendarGrid+59}px`}}>
      <Needle needleStyle={{transform: `translateY(${(timeNeedlePosition-12)}px)`}}/>
    </div>
  );

};

export default NeedleOverlayBox;
